<app-data-table #dt [columns]="tableColumns" [value]="importCells" [rightCaptionTemplate]="rightCaptionTemplate" [leftCaptionTemplate]="leftCaptionTemplatge">
  <ng-template #rightCaptionTemplate let-row="row">
    <div class="excelContainer">
      <span>Excel</span>
      <app-excel-file-load styleClass="excelUpload" tooltip="Upload Excel file to load Invoices"
                           (handleAfterLoad)="onSelectConvertToInvoices($event)">
      </app-excel-file-load>
      <button pButton class="icon-action" icon="fa fa-download" pTooltip="Download the Excel template to load invoices from legacy system" tooltipPosition="top"
              (click)="onClickDownloadExcelTemplate()">
      </button>
    </div>
  </ng-template>

  <ng-template #leftCaptionTemplatge>
    <button class="ui-button-secondary"
            (click)="onClickOpenPartialImport()">
      <i class="fa fa-import"></i> Partial Import Invoices
    </button>

  </ng-template>
</app-data-table>



<p-dialog *ngIf="displayPartialImportDialog" [(visible)]="displayPartialImportDialog"
          header="Partial Vendor Invoice Import" [modal]="true" [dismissableMask]="true" [responsive]="true" [style]="DialogStyle40">
  <div class="instruction-text">Timesheet  will be partially imported for this period.</div>
  <form #partialImportForm="ngForm">

    <div class="p-col-12">
      <div class="p-col-12 p-md-4 p-lg-4">
        <label>Vendor</label>
      </div>
      <div class="p-col-12 p-md-8 p-lg-8">
        <p-dropdown name="partialImportVendor" [placeholder]="Validation.DropdownPlaceholder"
                    [options]="vendorDropDown" [showClear]="true"
                    [(ngModel)]="partialImportVendor"></p-dropdown>
      </div>
    </div>

    <div class="p-col-12">
      <div class="p-col-12 p-md-4 p-lg-4">
        <label>Start Date*</label>
      </div>
      <div class="p-col-12 p-md-8 p-lg-8">
        <p-calendar name="partialImportStartDate" dataType="string" [dateFormat]="Format.PcalendarDate" [showIcon]="true" showButtonBar="true"
                    [monthNavigator]="true" [yearNavigator]="true" [yearRange]="yearRange"
                    [(ngModel)]="partialImportStartDate" required>
        </p-calendar>
      </div>
    </div>

    <div class="p-col-12">
      <div class="p-col-12 p-md-4 p-lg-4">
        <label>End Date*</label>
      </div>
      <div class="p-col-12 p-md-8 p-lg-8">
        <p-calendar  name="partialImportEndDate" dataType="string" [dateFormat]="Format.PcalendarDate" [showIcon]="true" showButtonBar="true"
                    [monthNavigator]="true" [yearNavigator]="true" [yearRange]="yearRange"
                    [(ngModel)]="partialImportEndDate" required>
        </p-calendar>
      </div>
    </div>
  </form>

  <p-footer>
    <div class="ui-dialog-buttonpane ui-helper-clearfix">
      <button pButton type="button" class="button-action" icon="fa fa-check" label="Partial Import"
              [disabled]="!partialImportForm?.form.valid"
              (click)="onClickPartialImportVendors()"></button>
      <button pButton type="button" class="button-inaction" icon="fa fa-close" label="Close"
              (click)="onClickCancelPartialImportVendorInvoices()"></button>
    </div>
  </p-footer>

</p-dialog>

